import { atom } from "recoil";

import { LoginAuthType, LoginFormFlow, SuperAdminPriceMode } from "../../enums";
import { getAccessToken } from "../../helpers/auth/auth.helpers";

export const isLoggedInAtom = atom<boolean>({
  key: "isLoggedInAtom",
  default: Boolean(getAccessToken()),
});

export const isLoginInProgressAtom = atom<boolean>({
  key: "isLoggingInProgressAtom",
  default: false,
});

export const loginErrorsAtom = atom<string[] | undefined>({
  key: "loginErrorsAtom",
  default: undefined,
});

export const loginParamsAtom = atom<Set<LoginAuthType> | undefined>({
  key: "loginParamsAtom",
  default: undefined,
});

export const loginFlowStepAtom = atom<LoginFormFlow>({
  key: "loginFlowStepAtom",
  default: LoginFormFlow.GENERIC_STEP,
});

export const mfaChallengeTokenAtom = atom<string | undefined>({
  key: "mfaChallengeTokenAtom",
  default: undefined,
});

export const isSelectCompanyOrRoleButtonActiveAtom = atom<boolean>({
  key: "isSelectCompanyOrRoleButtonActiveAtom",
  default: false,
});

export const isAdministrativeModeAtom = atom<boolean>({
  key: "isAdministrativeModeAtom",
  default: false,
});

export const priceModeAtom = atom<SuperAdminPriceMode>({
  key: "priceModeAtom",
  default: SuperAdminPriceMode.NotSet,
});

export const isSupplierPriceRatesPasswordVerifiedAtom = atom<boolean>({
  key: "isSupplierPriceRatesPasswordVerifiedAtom",
  default: false,
});
